"use client";

import styles from "./main-cta-btn.module.css";
import React, {AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode} from "react";
import {cn} from "@/lib/utils";

const BASE_CLASSES =
    "text-[12px] p-[12px] leading-none rounded-[8px] border border-stroke-gold font-semibold text-noble-black-900 cursor-pointer";

// Renders a `<button>` by default; pass `href` to render a styled `<a>` instead
// (used for progressive-enhancement CTAs that must work before hydration).
type MainCtaBtnProps =
    | ({children: ReactNode; disabled?: boolean; href?: undefined} & ButtonHTMLAttributes<HTMLButtonElement>)
    | ({children: ReactNode; href: string} & AnchorHTMLAttributes<HTMLAnchorElement>);

export const MainCtaBtn = (props: MainCtaBtnProps) => {
    if (props.href !== undefined) {
        const {children, className, ...rest} = props;
        return (
            <a className={cn(BASE_CLASSES, 'flex items-center justify-center', styles.Button, className)} {...rest}>
                {children}
            </a>
        );
    }

    const {children, disabled, className, ...rest} = props;
    return (
        <button
            className={cn(
                BASE_CLASSES,
                styles.Button,
                {[styles.ButtonDisabled]: disabled},
                className,
            )}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
};
